/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { IdentityMap } from '../models/identity-map';
import { PartyType } from '../models/party-type';
import { SystemEntity } from '../models/system-entity';
export interface PartyStub {

  /**
   * Avatar Token
   */
  avatarUrl?: string | null;

  /**
   * ID
   */
  id?: string | null;

  /**
   * Identities of the party
   */
  identities?: Array<IdentityMap> | null;

  /**
   * Is the party active?
   */
  isActive?: boolean;

  /**
   * Name
   */
  name?: string | null;
  partyType?: PartyType;
  type?: SystemEntity;
}

export class PartyStub {
  avatarUrl?: string | null;
  id?: string | null;
  identities?: IdentityMap[] | null;
  isActive?: boolean;
  name?: string | null;
  partyType?: PartyType;
  type?: SystemEntity;

  constructor(value: PartyStub) {
    this.avatarUrl = value?.avatarUrl;
    this.id = value?.id;
    this.identities = value?.identities?.map((x) => new IdentityMap(x));
    this.isActive = value?.isActive;
    this.name = value?.name;
    this.partyType = value?.partyType ? Object.entries(Object.values(PartyType)).flatMap((x) => x).find(x => x === value.partyType) as PartyType : undefined;
    this.type = value?.type ? Object.entries(Object.values(SystemEntity)).flatMap((x) => x).find(x => x === value.type) as SystemEntity : undefined;
  }
}
